// The spec-sheet forms' name rules — the two react-hook-form rules the donor's
// `GenericNameNoteDialogForm` and `SpecSheetLineDialogForm` both put on their
// name field (`required: 'This field is required'`, `maxLength: { value: 50,
// message: 'Max length is 50 characters' }`), shared by their two ports
// (`name-note-dialog.tsx`, `spec-line-dialog.tsx`). A rule and not a
// `maxlength`, so a longer name can be typed and is refused on submit.

/** react-hook-form's `required` message. */
export const REQUIRED_MESSAGE = "This field is required";

/** `maxLength: { value: 50, … }`. */
const NAME_MAX_LENGTH = 50;

/** The name's message, or `undefined` when it passes. */
export function specNameError(name: string): string | undefined {
  // react-hook-form's `required` fails the empty string only.
  if (name === "") return REQUIRED_MESSAGE;
  if (name.length > NAME_MAX_LENGTH) return "Max length is 50 characters";
  return undefined;
}
